import { gql } from '@apollo/client'

const listVirtualModules = gql(`
  query listVirtualModules($project: String)
  {
    listVirtualModules(project: $project)
    {
      items {
        id
        title
        key
        isActive
        assetTypes 
      }
      nextToken
    }
  }
`)

export default listVirtualModules
